<template xmlns="http://www.w3.org/1999/html">
  <div class="container">

    <main-top step-number="1"/>

    <div class="main-content">
      <div class="row white-box">

        <div class="dropbox" :class="{ hidden : !isLogin }" @click="onUploadClick"  >
          <input type="file" accept="" style="display: none;" id="fileup" @change="onUploadChange" multiple>
          <h2 v-if="files.length===0" class="text-center" style="font-size: 10px; color: gray;">
            点击选择要上传的文件或直接拖动到这里<br>
            (允许上传类型:pdf,doc,docx,xls,xlsx,ppt,pptx,jpg,jpeg,png,bmp)
          </h2>
          <div class="border m-2 d-inline-block p-4 " style="width: 100%" v-for="file in files">
            <div><h5 class="mt-0">{{ file.name }}</h5></div>
            <div class="progress">
              <div class="progress-bar progress-bar-striped"
                   :style="{ width: file.uploadPercentage+'%' }"></div>
            </div>
          </div>
        </div>


        <div v-if="isLogin">
          <div class="list order-list print-list animate">
            <div class="list-title tabbar" >
              <span class="title">我的文件</span>
              <!--<span class="tabbar-bar" :class="{ active : checkExt('all') }" v-on:click="selectExt('all')">ALL</span>-->
              <!--<span class="tabbar-bar" :class="{ active : checkExt('doc') }" v-on:click="selectExt('doc')">DOC</span>-->
              <!--<span class="tabbar-bar" :class="{ active : checkExt('ppt') }" v-on:click="selectExt('ppt')">PPT</span>-->
              <!--<span class="tabbar-bar" :class="{ active : checkExt('pdf') }" v-on:click="selectExt('pdf')">PDF</span>-->
              <!--<span class="tabbar-bar" :class="{ active : checkExt('xls') }" v-on:click="selectExt('xls')">EXCEL</span>-->




              <!--<span class="tabbar-bar" :class="{ active : checkExt('other') }" v-on:click="selectExt('other')">其他</span>-->
            </div>



            <div v-if="!userfile" class="col-lg-12 print-files">
              <div class="blank-file">
                <i class="icon-file"></i><br>无任何文件
              </div>
            </div>
            <div style="overflow:scroll;height: 500px">
              <table class="table table-noborder" style="min-height:100px;" >
                <tbody>

                <tr v-for="file in userfile">
                  <th scope="row"><i v-bind:class="['icon-fileext', 'icon-' + fileExt(file.fileName) + '-small']"></i>{{ file.fileName }}</th>
                  <!--<th scope="row"><i class="icon-fileext iconfont icon-pdf"></i>{{ file.fileName }}</th>-->
                  <td>上传时间 : {{ file.uploadTime.split(' ')[0] }}</td>
                  <td>
                    <a class="btn btn-default" @click="preview(file.id)">预览</a>
                    <!--<pdf ref="pdf"/>-->
                    <!--<a class="btn btn-default" data-toggle="modal" v-bind:data-target="'#Modal_readFile_' + file.id">预览</a>-->
                    <!--<modal-readfile :file="file"></modal-readfile>-->
                    <a class="btn btn-default" :href="'/print-setting/' + file.id" >打印</a>
                    <!--<router-link class="btn btn-default" :to="'/print-setting/' + file.id">打印</router-link>-->
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--<pagination :pageCount="pageCount" v-on:togglePage="togglePage" ref="pagination" v-show="pageCount > 1"></pagination>-->
        </div>
        <div v-else>
          <div class="col-lg-12 order-list print-files">
            <div class="blank-file">
              <i class="icon-file"></i><br>无任何已上传文件
            </div>
          </div>
        </div>
      </div>
    </div>

    <main-right/>



  </div>
</template>

<script>
  import {loading, ajax, fileExt} from '@/api/global'
  import Cookies from 'js-cookie'

  import MainTop from '@/components/MainTop'
  import MainRight from '@/components/MainRight'
  import Pagination from '@/components/Pagination'
  import ModalReadfile from '@/components/ModalReadfile'

  export default {
    name: "PageIndex",
    components: {
      MainTop,
      MainRight,
      Pagination,
      ModalReadfile
    },
    props: ['isLogin'],
    data: function () {
      return {
        files: [],
        userfile : null,
        page : 1,
        ext : 'all',
        pageCount : 1
      }
    },
    computed: {

    },
    mounted () {
      var dropbox = document.querySelector('.dropbox');
      dropbox.addEventListener('dragenter', this.onDrag, false);
      dropbox.addEventListener('dragover', this.onDrag, false);
      dropbox.addEventListener('drop', this.onDrop, false);
    },
    methods: {
      fileExt(file) {
        // console.info('filename:'+JSON.stringify(file));
        let filename = file;
        let index1=filename.lastIndexOf(".");
        let index2=filename.length;
        let type=filename.substring(index1+1,index2).toLowerCase();
        // console.info(type);
        return type;
      },
      preview(fileId) {
        var self = this;
        ajax({
          url : 'api/app-service/getPreview',
          type : 'get',
          data : {
            id : fileId
          },
          success : function (res) {
            var pdfFileUrl = ''+res.data;

            if (pdfFileUrl.indexOf('http:')<0) {
              alert('文件正在转化中，请稍后预览。');
            } else {
              self.showPdfFile(pdfFileUrl);
            }

          }
        });
      },
      showPdfFile(url) {
        this.$showPDF(url);
      },

      checkExt : function (ext) {
        return ext == this.ext;
      },
      selectExt : function (ext) {
        this.ext = ext;
        this.page = 1;
        this.pageCount = 1;
        this.$refs.pagination.curPage = 1;
        this.ajaxFiles();
        loading(true);
      },
      ajaxFiles : function () {
        var self = this;
        if (!self.isLogin) {
          console.info(' is not login ');
          return false;
        }
        console.info(' is login ');
        ajax({
          // mock : Mock.userfile,
          url : 'api/app-service/getMyFiles',
          type : 'get',
          data : {
            ext : self.ext == 'all' ? '' : self.ext,
            from : '',
            to : '',
            page : self.page
          },
          success : function (res) {
            // self.pageCount = res.totalPages;
            self.userfile = res.data;
            console.info(self.userfile);
            self.pageCount = self.userfile.length;
            console.info('Files Length : ' + self.pageCount);
            loading(false);
          }
        });
      },
      togglePage : function (page) {
        this.page = page;
        this.ajaxFiles();
      },
      initData : function () {
        console.info(' init data ');
        this.ext = this.$route.params.ext || 'all';
        this.ajaxFiles();
      },
      uploadFile: function (file) {
        var item = {
          name: file.name,
          uploadPercentage: 0
        };
        this.files.push(item);
        var fd = new FormData();
        fd.append('file', file);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/zuul/api/tool/file/upload', true);
        xhr.setRequestHeader('Authorization', Cookies.get("token"));

        xhr.onload = function(evt) {
          //$.hideLoading();
          //                  plus.nativeUI.closeWaiting();
          console.log("上传完成")
          console.log(evt.target.responseText);
          setTimeout(function() {
            alert('上传文件成功');
            // this.$vDialog.alert('上传文件成功', null, {messageType: 'success'});
            location.reload()
          }, 500);

          // this.$vDialog.alert('上传文件成功', null, {messageType: 'success'});
          // uploadComplete(evt.target.responseText, evt.target.status);
        }; //请求完成
        xhr.onerror = function() {
          alert('上传文件出错');
          // this.$vDialog.alert('上传文件出错', null, {messageType: 'error'});
        }; //请求失败


        xhr.upload.addEventListener('progress', function (e) {
          item.uploadPercentage = Math.round((e.loaded * 100) / e.total);
        }, false);
        xhr.send(fd);
      },
      onDrag: function (e) {
        e.stopPropagation();
        e.preventDefault();
      },
      onDrop: function (e) {
        e.stopPropagation();
        e.preventDefault();
        var fileList = e.dataTransfer.files;

        for (var i = 0; i !== fileList.length; i++) {
          if (!this.allowExt(fileList[i].name)) {
            alert('上传文件类型有误，请重新选择.');
            return;
          }
          if (fileList[i].size/1000/1000>100) {
            alert('上传文件超出100M限制，请重新选择.');
            return;
          }
        }
        for (var i = 0; i !== fileList.length; i++) {
          this.uploadFile(fileList[i]);
        }
      },
      allowExt(filename) {
        var extList = ['pdf','doc','docx','xls','xlsx','ppt','pptx','jpg','jpeg','png','bmp'];
        for(var i = 0; i < extList.length; i++){
          if(this.fileExt(filename) === extList[i]){
            return true;
          }
        }
        return false;
      },
      onUploadClick: function () {
        $("#fileup").click();
      },
      onUploadChange: function () {
        console.info('files upload onchange!');
        var fileList = document.getElementById("fileup").files;
        console.info(fileList);

        for (var i = 0; i !== fileList.length; i++) {
          if (!this.allowExt(fileList[i].name)) {
            alert('上传文件类型有误，请重新选择.');
            return;
          }
          if (fileList[i].size/1000/1000>100) {
            alert('上传文件超出100M限制，请重新选择.');
            return;
          }
        }
        for (var i = 0; i !== fileList.length; i++) {
          this.uploadFile(fileList[i]);
        }
      }
    },
    watch: {
      '$route' : 'initData'
      // '$route' (to, from) {
      //   this.$router.go(0);
      // }
    },
    created: function () {
      var self = this;
      self.initData();
      console.info('page-index-init');
    }
  }
</script>

<style scoped>
  .dropbox {
    border: .25rem dashed #9b9b9b;
    min-height: 5rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PageIndex.vue